import { SecureDataType } from '../services/securedata.sevice';

/** Route of the page that collects each secure data stage the agent can open. */
export const STAGE_ROUTES: Partial<Record<SecureDataType, string>> = {
    Start: 'pin',
    CustomerInfo: 'customer-information',
    CreditInfo: 'credit-information',
    TermsAndConditionInfo: 'terms-condition',
    OrderCheckList: 'order-checklist',
    FPVInfo: 'first-party-verification',
    NCVCQuestionnaire: 'ncvc-questionnaire',
    CustomerAccountSetupInfo: 'customer-account-setup',
    WindstreamCustomerAccountSetupInfo: 'windstream-customer-account-setup',
    PaymentInformationEntry: 'payment-information',
    OutstandingBalance: 'outstanding-balance',
    WirelessSetup: 'wireless-setup',
    upgradePaymentInformationEntry: 'wireless-upgrade-payment',
    WirelessAccountAuthentication: 'wireless-account-authentication',
    MBAInfo: 'mobile-business-agreement',
};

export function stageRoute(type: SecureDataType | undefined): string | undefined {
    return type ? STAGE_ROUTES[type] : undefined;
}
